var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 296,
    viewBox: "0 0 295 296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2979 105.222C38.2437 52.5647 87.1505 14.2419 145.014 14.2419C215.818 14.2419 273.216 71.6408 273.216 142.444C273.216 213.247 215.818 270.646 145.014 270.646C88.0803 270.646 39.8088 233.532 23.0882 182.177",
    stroke: "url(#paint0_linear_1407_3401)",
    strokeWidth: 18.6983,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M194.495 120.253C191.643 117.572 187.862 116.224 183.167 116.224C178.471 116.224 174.442 117.572 171.591 120.253C168.74 122.934 167.314 126.545 167.314 131.085V175.777C167.314 188.081 161.503 200.215 148.114 201.858C132.137 203.81 123.722 189.956 123.722 175.777V131.085C123.722 126.545 122.297 122.95 119.445 120.253C116.594 117.572 112.735 116.224 107.87 116.224C103.004 116.224 99.393 117.572 96.5417 120.253C93.6903 122.934 92.2646 126.545 92.2646 131.085V177.11C92.2646 210.954 115.308 230.96 145.433 231.053C145.464 231.053 145.495 231.053 145.526 231.053C145.557 231.053 145.588 231.053 145.619 231.053C175.744 230.975 198.787 210.954 198.787 177.11V131.085C198.787 126.545 197.362 122.95 194.51 120.253H194.495Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.776 99.5034C115.864 99.5034 122.42 92.947 122.42 84.8592C122.42 76.7715 115.864 70.2151 107.776 70.2151C99.6882 70.2151 93.1318 76.7715 93.1318 84.8592C93.1318 92.947 99.6882 99.5034 107.776 99.5034Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M181.942 99.1004C190.03 99.1004 196.586 92.544 196.586 84.4563C196.586 76.3685 190.03 69.8121 181.942 69.8121C173.854 69.8121 167.298 76.3685 167.298 84.4563C167.298 92.544 173.854 99.1004 181.942 99.1004Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1407_3401",
    x1: 147.757,
    y1: 4.94407,
    x2: 147.757,
    y2: 279.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2EAD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#B7E6D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#9DDCD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#71CCCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#4FC0CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#5CC7AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7ED957"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLightIcon);
export default __webpack_public_path__ + "static/media/logoLightIcon.95df024338c8a3ad49f08cbd40ce8d19.svg";
export { ForwardRef as ReactComponent };